import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { fieldSchemaObject } from '../fieldSchema'
import { Fields, validateProperty, validate, Card } from "../../Common"
import MessageModal from '../../../UI/Modal/MessageModal';
import { PageHeader } from '../../../Common';
import Joi from '@hapi/joi'
import groupService from '../../Group/services';
import { MenuItem, FormHelperText, TextField } from '@material-ui/core';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import "react-datepicker/dist/react-datepicker.css";

const screenCode = 'FIELD';


export function FieldAddEdit(props) {

    const { data, edit } = props.location;
    const [title, setTitle] = useState("Add Field");
    const [buttonName, setButtonName] = useState("Save");
    const [groups, setGroups] = useState();
    const [collectionPoint, setCollectionPoint] = useState();
    const [isChanged, setIsChanged] = useState(0);
    const [operationEntity, setOperationEntity] = useState();
    const [selectedCollectionpoint, setSelectedCollectionpoint] = useState();



    const [field, setField] = useState({
        groupID: "0",
        operationEntityID: "0",
        collectionPointID: "0",
        fieldCode: '',
        fieldName: '',
        fieldLocation: '',
        areaofaSection: '',
        typesofPlantsID: '0',
        drainageLengths: '',
        yearofPlanting: '',
        spaceBetweenPlants: '',
        numberOfTeaBushes: '',
        plantingTypeID: '0',
        numberOfShadeTrees: '',
        clonePercentage: '',
        seedlingPercentage: '',
        isActive: true
    });
    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(fieldSchemaObject).options({ allowUnknown: true });

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        setIsChanged(isChanged + 1);
    }, [field]);

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [field.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionpointDropDownData()
        )
    }, [field.operationEntityID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITFIELD');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        if (data && edit) {
            setTitle("Edit Field");
            setField(data);
            fillFieldsValues(data);
            setButtonName("Update");
        } else {
            setTitle("Add Field");
            var token = tokenService.getUserDetailsFromToken();
            setField({
                ...field,
                groupID: token.groupID,
                operationEntityID: token.operationEntityID
            });
        }

        trackPromise(
            getAllDropDownData()
        )
    }

    async function fillFieldsValues(data) {
        const collectionPointData = await services.getCollectionPointByID(data.collectionPointID);
        setSelectedCollectionpoint(collectionPointData);

        const collectionPoint = await services.getAllDivisionsByEstateID(collectionPointData.operationEntityID.toString());
        setCollectionPoint(collectionPoint);

        const operationEntity = await services.getOperationEntityByType(collectionPointData.groupID.toString());
        setOperationEntity(operationEntity);

        let day1 = data.yearofPlanting.split('T')[0]
        let day2 = day1.split('-')
        let final = day2[0] + '-' + day2[1]
        setField({
            ...data,
            groupID: collectionPointData.groupID.toString(),
            operationEntityID: collectionPointData.operationEntityID.toString(),
            collectionPointID: parseInt(collectionPointData.collectionPointID),
            fieldCode: data.fieldCode.toString(),
            fieldName: data.fieldName.toString(),
            fieldLocation: data.fieldLocation.toString(),
            areaofaSection: parseFloat(data.areaofaSection),
            yearofPlanting: final,
            typesofPlantsID: parseInt(data.typesofPlantsID),
            drainageLengths: parseFloat(data.drainageLengths),
            spaceBetweenPlants: parseFloat(data.spaceBetweenPlants),
            numberOfTeaBushes: parseInt(data.numberOfTeaBushes),
            plantingTypeID: parseInt(data.plantingTypeID),
            numberOfShadeTrees: parseInt(data.numberOfShadeTrees),
            clonePercentage: data.typesofPlantsID != 3 ? 0 : parseInt(data.clonePercentage),
            seedlingPercentage: data.typesofPlantsID != 3 ? 0 : parseInt(data.seedlingPercentage),
            isActive: data.isActive
        });
    }

    async function getAllDropDownData() {
        const group = await groupService.getGroupsForDropdown();
        setGroups(group);
    }

    async function getCollectionpointDropDownData() {
        const collectionPoint = await services.getAllDivisionsByEstateID(field.operationEntityID);
        setCollectionPoint(collectionPoint);
    }

    async function getOperationEntities() {
        const operationEntity = await services.getOperationEntityByType(field.groupID);
        setOperationEntity(operationEntity);
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.name === 'isActive' ? target.checked : target.value;

        if (target.name === "fieldCode") {
            if (target.value.length === 3) return false
        }

        const error = { ...errors };
        const errorMessage = validateProperty(target, fieldSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setField({
            ...field,
            [e.target.name]: value
        });
        setErrors(error);
    }

    async function handleSave(e) {
        e.preventDefault();

        const errorMessages = validate(schema, field)
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        if (!edit) {
            const response = await services.saveField(field);
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });
            afterSuccessfulyChanged(response.statusCode);
        } else {
            const response = await services.editData(field);
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });
            afterSuccessfulyChanged(response.statusCode);
        }
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({ pathname: '/field' })
            }, 1500);
        }
    }

    function onCancelClick() {
        setErrors({});
        clearState();
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setField({
            ...field,
            groupID: !permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: !permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            collectionPointID: "0",
            fieldCode: '',
            fieldName: '',
            fieldLocation: '',
            areaofaSection: '',
            typesofPlantsID: '0',
            drainageLengths: '',
            yearofPlanting: '',
            spaceBetweenPlants: '',
            numberOfTeaBushes: '',
            plantingTypeID: '0',
            numberOfShadeTrees: '',
            clonePercentage: '',
            seedlingPercentage: '',
            isActive: true
        });
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    function handleGroupDropdown(target) {
        validateInputs(target);

        setField({
            ...field,
            groupID: target.value,
            operationEntityID: '0',
            collectionPointID: '0'
        });
    }

    function handleOperationEntityDropdown(target) {
        validateInputs(target);

        setField({
            ...field,
            operationEntityID: target.value,
            collectionPointID: '0'
        });
    }

    function handleCollectionPointChange(target) {
        validateInputs(target);

        setField({
            ...field,
            collectionPointID: target.value,

        });
    }

    function handleClonePercentageChange(target) {
        setField({
            ...field,
            clonePercentage: target.value,
            seedlingPercentage: 100 - target.value,
        });
    }



    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, fieldSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setErrors(error);
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                    isButtonEnable={true}
                                    buttonText="Back to Listing"
                                    path="/field"
                                    isChanged={isChanged}
                                />
                            </div>
                            <hr />

                            <form onSubmit={(e) => handleSave(e)}>

                                <div className="row row-top-gap">
                                    <div className="col-md">
                                        <InputLabel shrink id="GroupID">Group</InputLabel>
                                        <Select
                                            fullWidth
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            id="groupID"
                                            name="groupID"
                                            value={field.groupID}
                                            onChange={(e) => handleGroupDropdown(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="operationEntityID">Estate</InputLabel>
                                        <Select
                                            fullWidth
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            value={field.operationEntityID}
                                            onChange={(e) => handleOperationEntityDropdown(e.target)}>
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(operationEntity)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="collectionPointID">Division</InputLabel>
                                        <Select
                                            fullWidth
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={field.collectionPointID}
                                            onChange={(e) => handleCollectionPointChange(e.target)}>
                                            <MenuItem value="0">--Division--</MenuItem>
                                            {generateDropDownMenu(collectionPoint)}
                                        </Select>
                                        {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                    </div>
                                </div>

                                <div className="row row-top-gap">
                                    <div className="col-md">
                                        <div className="form-group">
                                            <InputLabel>Field Code *</InputLabel>
                                            <TextField
                                                fullWidth
                                                type="number"
                                                maxLength="2"
                                                value={field.fieldCode}
                                                name="fieldCode"
                                                id="fieldCode"
                                                onChange={handleChange} />
                                            {errors["fieldCode"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["fieldCode"]}</FormHelperText>}
                                        </div>
                                    </div>
                                    <div className="col-md">
                                        <div className="form-group">
                                            <InputLabel>Field Name *</InputLabel>
                                            <TextField
                                                fullWidth
                                                type="text"
                                                value={field.fieldName}
                                                name="fieldName"
                                                id="fieldName"
                                                onChange={handleChange} />
                                            {errors["fieldName"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["fieldName"]}</FormHelperText>}
                                        </div>
                                    </div>
                                    <div className="col-md">
                                        <div className="form-group">
                                            <InputLabel>Field Location</InputLabel>
                                            <TextField
                                                fullWidth
                                                type="text"
                                                value={field.fieldLocation}
                                                name="fieldLocation"
                                                id="fieldLocation"
                                                onChange={handleChange} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row row-top-gap">
                                    <div className="col-md">
                                        <div className="form-group">
                                            <InputLabel>Area Of a Section</InputLabel>
                                            <TextField
                                                fullWidth
                                                type="number"
                                                value={field.areaofaSection}
                                                name="areaofaSection"
                                                id="areaofaSection"
                                                onChange={handleChange} />
                                            {errors["areaofaSection"] && <FormHelperText className="text text-danger">{errors["areaofaSection"]}</FormHelperText>}

                                        </div>
                                    </div>
                                    <div className="col-md">
                                        <div className="form-group">
                                            <InputLabel>Year Of Planting</InputLabel>
                                            <TextField
                                                fullWidth
                                                name="yearofPlanting"
                                                id="yearofPlanting"
                                                type="month"
                                                value={field.yearofPlanting}
                                                onChange={(e) => handleChange(e)}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                            {errors["yearofPlanting"] && <FormHelperText className="text text-danger">{errors["yearofPlanting"]}</FormHelperText>}
                                        </div>
                                    </div>
                                    <div className="col-md">
                                        <div className="form-group">
                                            <InputLabel shrink id="TypesofPlantsID">Types of Plants</InputLabel>
                                            <Select
                                                fullWidth
                                                id="typesofPlantsID"
                                                name="typesofPlantsID"
                                                value={field.typesofPlantsID}
                                                onChange={handleChange}>
                                                <MenuItem value="0">--Select Types of Plants--</MenuItem>
                                                <MenuItem value="1">Clone</MenuItem>
                                                <MenuItem value="2">Seedling</MenuItem>
                                                <MenuItem value="3">Both</MenuItem>
                                            </Select>
                                        </div>
                                    </div>
                                </div>

                                {field.typesofPlantsID == 3 ? (
                                    <>
                                        <div className="row row-top-gap">
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <InputLabel>Clone (%)</InputLabel>
                                                    <TextField
                                                        fullWidth
                                                        type="number"
                                                        value={field.clonePercentage}
                                                        name="clonePercentage"
                                                        id="clonePercentage"
                                                        onChange={(e) => handleClonePercentageChange(e.target)} />

                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <InputLabel>Seedling (%)</InputLabel>
                                                    <TextField
                                                        fullWidth
                                                        type="number"
                                                        value={field.seedlingPercentage}
                                                        name="seedlingPercentage"
                                                        id="seedlingPercentage"
                                                    />

                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ) : null}
                                <div className="row row-top-gap">
                                    <div className="col-md">
                                        <div className="form-group">
                                            <InputLabel>Drainage Lengths</InputLabel>
                                            <TextField
                                                fullWidth
                                                type="number"
                                                value={field.drainageLengths}
                                                name="drainageLengths"
                                                id="drainageLengths"
                                                onChange={handleChange} />
                                            {errors["drainageLengths"] && <FormHelperText className="text text-danger">{errors["drainageLengths"]}</FormHelperText>}

                                        </div>
                                    </div>
                                    <div className="col-md">
                                        <div className="form-group">
                                            <InputLabel>Space Between Plants</InputLabel>
                                            <TextField
                                                fullWidth
                                                type="number"
                                                value={field.spaceBetweenPlants}
                                                name="spaceBetweenPlants"
                                                id="spaceBetweenPlants"
                                                onChange={handleChange} />
                                            {errors["spaceBetweenPlants"] && <FormHelperText className="text text-danger">{errors["spaceBetweenPlants"]}</FormHelperText>}

                                        </div>
                                    </div>
                                    <div className="col-md">
                                        <div className="form-group">
                                            <InputLabel>Number Of Tea Bushes</InputLabel>
                                            <TextField
                                                fullWidth
                                                type="number"
                                                value={field.numberOfTeaBushes}
                                                name="numberOfTeaBushes"
                                                id="numberOfTeaBushes"
                                                onChange={handleChange} />
                                            {errors["numberOfTeaBushes"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["numberOfTeaBushes"]}</FormHelperText>}

                                        </div>
                                    </div>
                                </div>
                                <div className="row row-top-gap">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <InputLabel shrink id="PlantingTypeID">Planting Type</InputLabel>
                                            <Select
                                                fullWidth
                                                id="plantingTypeID"
                                                name="plantingTypeID"
                                                value={field.plantingTypeID}
                                                onChange={handleChange}>
                                                <MenuItem value="0">--Select Planting Type--</MenuItem>
                                                <MenuItem value="1">New Plantation</MenuItem>
                                                <MenuItem value="2">Uprooting</MenuItem>
                                                <MenuItem value="3">Dead Bushes</MenuItem>

                                            </Select>
                                            {errors["plantingTypeID"] && <FormHelperText className="text text-danger">{errors["plantingTypeID"]}</FormHelperText>}

                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <InputLabel>Number Of Shade Trees</InputLabel>
                                            <TextField
                                                fullWidth
                                                type="number"
                                                value={field.numberOfShadeTrees}
                                                name="numberOfShadeTrees"
                                                id="numberOfShadeTrees"
                                                onChange={handleChange} />
                                            {errors["numberOfShadeTrees"] && <FormHelperText className="text text-danger">{errors["numberOfShadeTrees"]}</FormHelperText>}

                                        </div>
                                    </div>
                                </div>

                                <label>Active</label>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <input
                                            className="mr-2"
                                            id="isActive"
                                            switch="none"
                                            type="checkbox"
                                            name="isActive"
                                            onChange={(e) => handleChange(e)}
                                            checked={field.isActive}
                                        />
                                        <label htmlFor="isActive" data-on-label="Yes"
                                            data-off-label="No">
                                        </label>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, field)}
                                        type="submit"
                                        className="btn btn-primary"
                                        value={buttonName}
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div >
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment >)
}